module.exports = __webpack_public_path__ + "static/media/adminIcon01.ef9fb600.svg";